import React, { useState } from "react";
import { Volume2, Search } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PHRASES, speakArabic, hasArabicVoice } from "@/lib/phrases";
import { trackEvent } from "@/lib/analytics";

/** 20 essential phrases with on-device Arabic pronunciation (no network needed once a voice is installed). */
export default function PhrasesTab() {
  const { lang, t } = useLang();
  const [q, setQ] = useState("");
  const [playing, setPlaying] = useState(-1);
  const col = lang === "ar" ? "en" : lang;
  const list = PHRASES.map((p, i) => ({ ...p, i })).filter((p) => !q || `${p[col]} ${p.tr} ${p.ar}`.toLowerCase().includes(q.toLowerCase()));
  const play = (p) => { trackEvent("phrase_play", { i: p.i }); setPlaying(p.i); speakArabic(p.ar); setTimeout(() => setPlaying(-1), 1800); };
  return (
    <div className="space-y-3" data-testid="kit-phrases">
      <label className="flex items-center gap-2 rounded-2xl border border-stoneLine bg-card px-3 py-2"><Search className="w-4 h-4 text-muted-foreground" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("phrases_search")} className="flex-1 bg-transparent text-sm outline-none" data-testid="phrases-search" /></label>
      {!hasArabicVoice() && <p className="text-xs text-muted-foreground" data-testid="phrases-voice-hint">{t("phrases_voice_hint")}</p>}
      <ul className="space-y-2">
        {list.map((p) => (
          <li key={p.i} className="rounded-2xl border border-stoneLine bg-card p-3 flex items-center gap-3" data-testid={`phrase-${p.i}`}>
            <button onClick={() => play(p)} className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 transition-colors ${playing === p.i ? "bg-ochre text-white" : "bg-ochre/10 text-ochre hover:bg-ochre hover:text-white"}`} aria-label={t("phrases_play")} data-testid={`phrase-play-${p.i}`}><Volume2 className={`w-5 h-5 ${playing === p.i ? "animate-pulse" : ""}`} /></button>
            <span className="min-w-0 flex-1">
              <span className="block font-display text-xl text-ink leading-tight" dir="rtl">{p.ar}</span>
              <span className="block text-xs text-ochre italic">{p.tr}</span>
              <span className="block text-sm text-ink/80">{p[col]}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
